<div class="animated fadeIn">
  <!-- ── Section 1: Order Statistics ── -->
  <div class="kite-section-card">
    <div class="kite-section-title flex-wrap gap-2">
      <span>Order Statistics</span>
      <div class="section-actions">
        <app-button *appHasPermission="['orders', 'create']"
          variant="primary"
          size="sm"
          icon="fa fa-plus"
          (onClick)="navigateToCreateOrder()">
          Create Order
        </app-button>
      </div>
    </div>
    <div class="row align-items-end g-2 mt-1">
      <app-read-only-field label="Tank installation date" class="col-xl-3 col-md-6 col-sm-6 mb-2"
        [value]="statsForm()?.tank_install_date"></app-read-only-field>
      <app-read-only-field label="Total orders" class="col-xl-3 col-md-6 col-sm-6 mb-2"
        [value]="statsForm()?.total_orders"></app-read-only-field>
      <app-read-only-field label="Orders pending" class="col-xl-3 col-md-6 col-sm-6 mb-2"
        [value]="statsForm()?.pending_orders"></app-read-only-field>
      <app-read-only-field label="Orders completed" class="col-xl-3 col-md-6 col-sm-6 mb-2"
        [value]="statsForm()?.close_orders"></app-read-only-field>
    </div>
  </div>

  <!-- ── Section 2: Orders List ── -->
  <div class="kite-section-card">
    <div class="kite-section-title flex-wrap gap-2">
      <span>Orders List</span>
      <div class="section-actions" style="min-width: 250px;">
        <app-search-input [placeholder]="'Search orders'" (searchChange)="onSearch($event)"></app-search-input>
      </div>
    </div>
    <div class="w-100 position-relative">
      <!-- Tier 2: wj-flex-grid + wj-flex-grid-column → app-kite-grid -->
      <app-kite-grid
        [columnDefs]="columnDefs"
        [rowData]="pagedOrders()"
        [totalRecords]="filteredOrders().length"
        [pageSize]="pageSize"
        (pageChange)="refreshData($event)"
        (cellClicked)="onCellClicked($event)">
      </app-kite-grid>
    </div>
  </div>
</div>

@if (isLoading()) {
  <app-page-loading [absolute]="true"></app-page-loading>
}